import { render, staticRenderFns } from "./DCA.vue?vue&type=template&id=6d5cba62&"
import script from "./DCA.vue?vue&type=script&lang=js&"
export * from "./DCA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports